export default "__VITE_ASSET__a0a7afb3__"